const INITIAL_STATE = {
  paises: { data: [] },
  estados: { data: [] },
  cidades: { data: [] },
  bairros: { data: [] }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ENDERECO_PAISES_FETCH':
      return { ...state, paises: action.payload }
    case 'ENDERECO_ESTADOS_FETCH':
      return { ...state, estados: action.payload }
    case 'ENDERECO_CIDADES_FETCH':
      return { ...state, cidades: action.payload }
    case 'ENDERECO_BAIRROS_FETCH':
      return { ...state, bairros: action.payload }
    default:
      return state
  }
}
